import * as moduleExports from './index.js';
export default moduleExports;
